/**
 * @class DataTableRowGroup
 */

import * as React from 'react';

export const DataTableRowGroup: React.FunctionComponent<any> = () => {
  return null;
};
